export const server =  '/HdvCezaneFonuApi' //'https://localhost:44390'  

export const webAPIUrl = `${server}/api`
